import React from 'react';
import {UserContextType} from 'components/triggers/UserContextType';

export default class UserIsAnyConditionComponent extends React.Component {
  render() {
    const {contextType} = this.props;
    const anybody = (
      <span className="condition-action" onClick={this.props.onClick}>
        anybody
      </span>
    );
    return (
      <div>
        {contextType === UserContextType.USER && <span>{anybody} reviews a call</span>}
        {contextType === UserContextType.CALLER && <span>is placed by {anybody}</span>}
        {contextType === UserContextType.CALL && <span>the caller is {anybody}</span>}
      </div>
    );
  }
}
